import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAdminToken(token) {
  if (token) {
    api.defaults.headers.common["x-admin-token"] = token;
    localStorage.setItem("cometa_admin_token", token);
  } else {
    delete api.defaults.headers.common["x-admin-token"];
    localStorage.removeItem("cometa_admin_token");
  }
}

const stored = typeof window !== "undefined" ? localStorage.getItem("cometa_admin_token") : null;
if (stored) api.defaults.headers.common["x-admin-token"] = stored;
